import request from "@/utils/request";

export function getAllProgenyOptions() {
    return request({
        url: "/api/services/app/Progeny/GetAllForDropDown",
        method: "GET"
    });
}

export function progenyGet(params) {
    return request({
        url: "/api/services/app/Progeny/Get",
        method: "GET",
        params
    });
}

export function progenyCreate(data) {
    return request({
        url: "/api/services/app/Progeny/Create",
        method: "POST",
        data
    });
}

export function progenyUpdate(data) {
    return request({
        url: "/api/services/app/Progeny/Update",
        method: "PUT",
        data
    });
}

export function progenyDelete(params) {
    return request({
        url: "/api/services/app/Progeny/Delete",
        method: "DELETE",
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/progeny.js